const isBstockBlue = (listing: { inventoryType?: string }) =>
  listing.inventoryType === 'B-Stock Blue'

export default isBstockBlue
